import React from 'react';
import { Button, Paragraph, Stack, Caption, LinkText } from '@mediahuis/chameleon-react';
import { useQueryParams } from '../../hooks/useQueryParams';
import './bundlingUpgrade.css';
import { Trans, useTranslation } from 'react-i18next';
import { useBrandGroupConfig } from '../../hooks/useBrandGroupConfig';

const brandUrls: { [key: string]: string } = {
  dvn: 'https://abonnement.dvhn.nl/upgrade-2',
  lcd: 'https://abonnement.lc.nl/upgrade-2',
  frd: 'https://abonnement.frieschdagblad.nl/',
  ge: 'https://www.gooieneemlander.nl/abonnement/on-ge-reg/',
  hd: 'https://www.haarlemsdagblad.nl/abonnement/on-hd-reg/',
  yc: 'https://www.ijmuidercourant.nl/abonnement/on-ic-reg/',
  ld: 'https://www.leidschdagblad.nl/abonnement/on-ld-reg/',
  dl: 'https://aboshop.limburger.nl/',
  nhd: 'https://www.noordhollandsdagblad.nl/abonnement/on-nhd-reg/',
};

const i18nKeys: { [key: string]: { [key: string]: string } } = {
  upgrade: {
    noAccessText: 'bundling.upgrade.noAccessText',
    description: 'bundling.upgrade.description',
    buttonText: 'bundling.upgrade.buttonText',
  },
  default: {
    noAccessText: 'bundling.noSubscription.noAccessText',
    description: 'bundling.noSubscription.description',
    buttonText: 'bundling.noSubscription.buttonText',
  },
};

function BundlingUpgrade() {
  const { t } = useTranslation();
  const brandGroupConfigHook = useBrandGroupConfig();
  const { brand, initiateLoginUri, screenType } = useQueryParams();
  const brandConfig = brandGroupConfigHook.getBrandConfigFromBrandId(brand);

  const handleBackLink = () => {
    if (initiateLoginUri) {
      window.location.href = initiateLoginUri;
    }
  };

  const handleUpgradeLink = () => {
    if (brand) {
      const upgradeUrl = brandUrls[brand];
      if (upgradeUrl) {
        window.location.href = upgradeUrl;
      }
    }
  };

  const keys = screenType ? i18nKeys[screenType] || i18nKeys.default : i18nKeys.default;

  return (
    <Stack alignItems="center" flexDirection="column" className="bundling-upgrade px-6 m-auto">
      <Paragraph size="Paragraph" className="bundling-upgrade__text--dark bold text-center mt-7">
        <Trans i18nKey={keys.noAccessText} values={{ brand: brandConfig?.name }}></Trans>
      </Paragraph>
      <Caption size="lg" className="bundling-upgrade__text--light text-center">
        <Trans i18nKey={keys.description} values={{ brand: brandConfig?.name }} />
      </Caption>
      <Button
        size="lg"
        onClick={handleUpgradeLink}
        appearance="primary"
        data-cy="upgradeButton"
        className="mb-3">
        {t(keys.buttonText)}
      </Button>
      <LinkText
        size="Paragraph"
        onClick={handleBackLink}
        className="bundling-upgrade__text--light text-center with-underline">
        {t('bundling.backLink')}
      </LinkText>
    </Stack>
  );
}

export default BundlingUpgrade;
